export class UILegend {
  id: number;
  status: string;
  color: string;
  value: string;

  constructor() {
    this.id = null;
    this.status = null;
    this.color = null;
    this.value = null;
  }
}
